import React from 'react';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { BonusBundle } from '../components/BonusBundle';
import { Testimonials } from '../components/Testimonials';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
export function LandingPage() {
  return <div className="min-h-screen bg-cream-light font-sans text-gray-900" data-id="element-194">
      <main data-id="element-195">
        <Hero data-id="element-196" />
        <SocialProof data-id="element-197" />
        <Problem data-id="element-198" />
        <Solution data-id="element-199" />
        <BonusBundle data-id="element-200" />
        <Testimonials data-id="element-201" />
        <Pricing data-id="element-202" />
        <FAQ data-id="element-203" />
      </main>

      <footer className="bg-gray-900 text-white py-12 text-center" data-id="element-204">
        <div className="max-w-7xl mx-auto px-4" data-id="element-205">
          <p className="font-serif text-2xl font-bold mb-4" data-id="element-206">MÁS AÑOS JUNTOS</p>
          <p className="text-gray-400 text-sm mb-8" data-id="element-207">
            El Método Maestro de Bio-Nutrición y Convivencia
          </p>
          <div className="flex justify-center space-x-6 text-sm text-gray-500 mb-8" data-id="element-208">
            <a href="#" className="hover:text-white transition-colors" data-id="element-209">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-210">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-211">
              Contacto
            </a>
          </div>
          <p className="text-gray-600 text-xs" data-id="element-212">
            © {new Date().getFullYear()} Más Años Juntos. Todos los derechos
            reservados.
            <br data-id="element-213" />
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>
    </div>;
}